export enum PAYMENT_TYPE {
	Cheque = 0,
	Traite = 1,
	Virement = 2,
	Prelevement = 3,
	Espece = 4,
	Autre = 100,
}
